import { MessageBannerConfig } from '@zipari/shared-ds-util-messages';
import { ConfirmationModalConfig } from './ConfirmationModal.models';

export interface BrowserSupportConfig {
  showBanner: boolean;
  showModal: boolean;
  banner: MessageBannerConfig;
  supportedBrowsers: Array<string>;
  modal: ConfirmationModalConfig;
}
